export default "__VITE_ASSET__6uKfhbkM__"